export default "__VITE_ASSET__BigO7v56__"